<div [ngClass]="{'blank-page': router.url === '/error-500' || router.url === '/login'}">
    <app-sidebar *ngIf="authenticationService.isLoggedIn"></app-sidebar>
    <div class="main-content d-flex flex-column" [ngClass]="{'active': isToggled}">
        <app-header *ngIf="authenticationService.isLoggedIn"></app-header>
        <router-outlet></router-outlet>
        <div class="flex-grow-1"></div>
        <app-footer *ngIf="authenticationService.isLoggedIn"></app-footer>
    </div>
</div>